// La police embarquée dans les PDFs (Amiri) ne contient PAS les lettres
// roumaines à virgule souscrite — U+0218/U+0219 (Șș) et U+021A/U+021B (Țț).
// jsPDF n'a pas de fallback : il n'imprime rien du tout à leur place. D'où
// « CHITANA » au lieu de « CHITANȚA » et « Judeul » au lieu de « Județul ».
//
// Amiri contient en revanche les variantes historiques à cédille (U+0162/0163
// Ţţ, U+015E/015F Şş), visuellement quasi identiques et parfaitement lisibles
// en roumain. On substitue donc au moment du dessin.
const COMMA_TO_CEDILLA = {
  "Ș": "Ş", // Ș -> Ş
  "ș": "ş", // ș -> ş
  "Ț": "Ţ", // Ț -> Ţ
  "ț": "ţ", // ț -> ţ
};

/** Rend une chaîne imprimable avec Amiri (accepte aussi un tableau de lignes). */
export function toAmiriRomanian (value) {
  if (Array.isArray(value)) return value.map(toAmiriRomanian);
  if (typeof value !== "string") return value;
  return value.replace(/[ȘșȚț]/g, (c) => COMMA_TO_CEDILLA[c]);
}

/**
 * Enveloppe `doc.text` d'un document jsPDF pour que TOUT texte dessiné passe
 * par la substitution — plus fiable que de se souvenir d'appeler le helper à
 * chaque appel.
 */
export function patchJsPdfRomanian (doc) {
  if (!doc || doc.__roDiacriticsPatched) return doc;
  const originalText = doc.text.bind(doc);
  doc.text = function (text, ...rest) {
    return originalText(toAmiriRomanian(text), ...rest);
  };
  doc.__roDiacriticsPatched = true;
  return doc;
}
